import React from 'react';
import classNames from 'classnames/bind';
import { node, string, bool } from 'prop-types';
import styles from './with-subtitle.scss';

const cx = classNames.bind(styles);
/*
 Note that the order of header and content is reversed with styling to keep the
 markup optimal.
 */
const WithSubtitle = ({ children, title, className, contentClassName, reversed }) => {
  const mainStyle = cx(styles.main, {
    [`${className}`]: className,
    reversed,
  });
  const titleStyle = cx(styles.title, {
    titleReversed: reversed,
  });
  const contentStyle = cx(styles.content, {
    [`${contentClassName}`]: contentClassName,
    contentReversed: reversed,
  });

  return (
    <div className={mainStyle}>
      <div className={contentStyle}>
        <header className={titleStyle}>
          {title}
        </header>
        {children}
      </div>
    </div>
  );
};

WithSubtitle.propTypes = {
  title: string.isRequired,
  children: node.isRequired,
  className: string,
  contentClassName: string,
  /* Indicates that you want to flip the order of the title and the child embedded in this decorator */
  reversed: bool,
};

export default WithSubtitle;



// WEBPACK FOOTER //
// ./src/components/WithSubtitle/index.js